import script from "./HandleSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./HandleSelector.vue?vue&type=script&setup=true&lang=js"

import "./HandleSelector.vue?vue&type=style&index=0&id=4f57b3a5&lang=scss"

const __exports__ = script;

export default __exports__